import { BsFillChatLeftTextFill, BsFillSendFill } from 'react-icons/bs'
import { BsFillStarFill, BsStar } from 'react-icons/bs';
import { FaBook } from 'react-icons/fa'
import { BiSolidUserCircle } from 'react-icons/bi';
import Avatar, { genConfig } from 'react-nice-avatar';
import { Card, Button, Form, Badge, Row, Col, Placeholder, Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from 'react';
import Linkify from 'linkify-react';
import StyleComment from '../../util/StyleComment';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { selectLogin } from '../../features/login/login'
import { updateEditID } from '../../features/professorEditID/professorEditID';
import { update } from '../../features/searchKeyword/searchKeyword';
import { selectName } from '../../features/name/name';
import useIsVisible from '../../hooks/useIsVisible';
import './ProfessorCommentItem.css';

const fetch_content_url = process.env.REACT_APP_API_URL + '/professor_reviews/reviews/all';
const delete_url = process.env.REACT_APP_API_URL + '/professor_reviews/reviews/';
const specialChar = ['⊕', '▲', '★', '￡', '◆', '▼', '￠', '￥', '@', '＆'];
const linkifyOptions = { target: '_blank', rel: 'noopener noreferrer' };


const CommentItem = (props) => {
  const [content, setContent] = useState("");
  const [styledComment, setStyledComment] = useState([]);
  const [rating, setRating] = useState(0);
  const [displayFullContent, setDisplayFullContent] = useState(false);
  const [reply, setReply] = useState([]);
  const [lastYpos, setLastYpos] = useState(0);
  const [newReply, setNewReply] = useState('');
  const [loading, setLoading] = useState(false);
  const [moreLoading, setMoreLoading] = useState(false);
  const [editingReply, setEditingReply] = useState(false);
  const [showDeleteComment, setShowDeleteComment] = useState(false);
  const [authorID, setAuthorID] = useState();
  const windowWidth = useSelector(selectWindowWidth);
  const login = useSelector(selectLogin);
  const name = useSelector(selectName);
  const visibleRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [config] = useState(() => genConfig({ bgColor: '#FFD700', shirtStyle: 'polo' }));
  

  const isVisible = useIsVisible(visibleRef);

  useEffect(() => {
    if (isVisible) {
      getContent(props.ele.id);
    }
  }, [isVisible])

  const getContent = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`${fetch_content_url}?review_id=${id}`);
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }
  
      const data = await response.json();
      console.log("API Response in CommentItem:", data);
      if (!data.reviews || !Array.isArray(data.reviews) || data.reviews.length === 0) {
        throw new Error("API response is empty or not an array");
      }
  
      const review = data.reviews[0];
      if (!review.review_content) {
        throw new Error("review_content is undefined in the first review");
      }
  
      setAuthorID(review.user_id || "Unknown");
      let fullContent = review.review_content;
  
      const styledStr = StyleComment(fullContent);
      // setStyledComment(styledStr.split("\n").filter((str) => str !== ""));
      setStyledComment(styledStr.split("\n"));
  
      if (windowWidth >= 600 && fullContent.length > 60) {
        fullContent = fullContent.slice(0, 60) + "......";
      } else if (windowWidth < 600 && fullContent.length > 40) {
        fullContent = fullContent.slice(0, 40) + "......";
      }
  
      setRating(review.rating || 0);
      setContent(fullContent);
    } catch (error) {
      console.error("Error fetching content:", error.message);
      setContent("Unable to fetch review content.");
    } finally {
      setLoading(false);
    }
  };
  /*const getContent = async (id) => {
    setLoading(true);
    const response = await fetch(`${fetch_content_url}?review_id=${id}`).then((res) => {
      return res.json();
    })
    setAuthorID(response.user_id);
    let fullContent = response.review_content;
    const styledStr = StyleComment(fullContent);
    setStyledComment(styledStr.split('\n').filter(str => str !== ''));
    if (windowWidth >= 600) {
      if (fullContent.length > 60) {
        fullContent = fullContent.slice(0, 60) + '......';
      }
    } else {
      if (fullContent.length > 40) {
        fullContent = fullContent.slice(0, 40) + '......';
      }
    }
    setRating(response.rating);
    setContent(fullContent);
    setLoading(false);
  }*/

  const handleShowMore = async (e) => {
    e.preventDefault();

    if (displayFullContent === false) {
      /*if (reply.length === 0) {
        setMoreLoading(true);
        const replyRes = await fetch(`${reply_url}?id=${props.ele.id}`)
          .then((res) => {
            if (res.ok) return res.json();
            else return [];
          })
        setReply(replyRes);
        setMoreLoading(false);
      }*/
      setLastYpos(window.scrollY);
    } else {
      //if (editingReply) setEditingReply(false);
      window.scrollTo({
        top: lastYpos,
        behavior: 'instant'
      })
    }

    setDisplayFullContent(!displayFullContent);
  }

  const handleEdit = (e) => {
    e.preventDefault();
    dispatch(updateEditID(props.ele.id));
    navigate('/professor/new');
  }

  const handleClickDelete = (e) => {
    e.preventDefault();
    setShowDeleteComment(true);
  }

  const handleDeleteComment = async (e) => {
    e.preventDefault();
    await fetch(`${delete_url}${props.ele.id}`, {
      method: 'DELETE',
      credentials: 'include'
    })
    setShowDeleteComment(false);
    window.location.reload();
  }

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        i <= rating ? (
          <BsFillStarFill 
            key={i} 
            color="#FFD700" 
            size={20} 
            style={{ marginRight: '8px' }}
          />
        ) : (
          <BsStar 
            key={i} 
            color="#FFD700" 
            size={20} 
            style={{ marginRight: '8px' }}
          />
        )
      );
    }
    return stars;
  };

  return (
    <div
      bg='light'
      text='dark'
      ref={visibleRef}
      className="card mb-3 border-0"
      style={{ height: 'max-content', width: windowWidth < 900 ? '90%' : '80%', margin: 'auto', color: '#4b3615', fontFamily: 'Noto Sans TC' }}
    >
      <Modal show={showDeleteComment} onHide={() => setShowDeleteComment(false)}>
        <Modal.Header closeButton>
          <Modal.Title>確認刪除</Modal.Title>
        </Modal.Header>
        <Modal.Body>確認要刪除心得嗎？</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteComment(false)}>
            取消
          </Button>
          <Button variant="danger" onClick={handleDeleteComment}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Card.Title
        style={{ marginTop: '20px', marginLeft: '20px' }}
      >
        <p style={{ fontSize: windowWidth >= 600 ? '18px' : '16px' }} className='d-flex align-items-center'>
          {/*avatar === null ? (
          <BiSolidUserCircle size={windowWidth >= 600 ? 23 : 20} color="black" style={{ marginRight: '10px' }} />
          ) : (
            <Avatar
              style={{ 
                width: windowWidth >= 600 ? '1.8rem' : '1.3rem', 
                height: windowWidth >= 600 ? '1.8rem' : '1.3rem',
                marginRight: '10px' }}
              {...config}
            />
          )*/}
          <Avatar
            style={{ 
              width: windowWidth >= 600 ? '1.8rem' : '1.3rem', 
              height: windowWidth >= 600 ? '1.8rem' : '1.3rem',
              marginRight: '10px' }}
            {...config}
          />
          匿名
        </p>
      
        <FaBook
          size={windowWidth >= 600 ? 20 : 18}
          color='#4b3615'
          style={{ marginBottom: windowWidth >= 600 ? '5px' : '2px', marginRight: '10px' }}
        />
        <span 
          style={{ 
            fontSize: windowWidth >= 600 ? '20px' : '18px',
            cursor: 'pointer',
          }}
          className='professor-name'
          onClick={() => dispatch(update(props.ele.professor_name))}
        >
          {props.ele.professor_name}
          {props.ele.institute_name && (
            <span style={{ marginLeft: '8px', color: '#7a6a55', fontSize: '14px' }}>
              ({props.ele.institute_name})
            </span>
          )}
        </span>
        {windowWidth < 600 && <br />}
      </Card.Title>
       <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
        {renderStars(rating)}
      </div>
      {loading ?
        <Placeholder
          as={Card.Text}
          animation="glow"
          style={{ marginLeft: '20px', marginBottom: '20px', marginRight: '20px' }}
        >
          <Placeholder xs={12} />
        </Placeholder>
        :
        <Card.Text
          style={{ marginLeft: '22px', marginBottom: '20px', marginRight: '20px' }}
        >
          {displayFullContent ? styledComment.map((line, index) => {
            const trimmed = line.trim();
            const isTitle = specialChar.some(char =>
              trimmed.startsWith(char) && trimmed.endsWith(char)
            );

            if (trimmed === '') {
              return <br key={index} />;
            }

            if (isTitle) {
              return (
                <div
                  key={index}
                  style={{
                    fontWeight: '500',
                    fontSize: windowWidth >= 600 ? '20px' : '18px',
                    fontFamily: 'Noto Sans TC',
                    margin: '0'
                  }}
                >
                  {trimmed}
                </div>
              );
            }

            return (
              <div
                key={index}
                style={{
                  fontSize: windowWidth >= 600 ? '18px' : '16px',
                  fontFamily: 'Noto Sans TC',
                  margin: '0'
                }}
              >
                <Linkify options={linkifyOptions}>{line}</Linkify>
              </div>
            );
          }) : <Linkify options={linkifyOptions}>{content}</Linkify>}
        </Card.Text>
      }

      {displayFullContent &&
        (moreLoading ?
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{ marginLeft: '20px', marginBottom: '20px', marginRight: '20px' }}
          >
            <Placeholder xs={1} />
            <Placeholder xs={12} />
          </Placeholder>
          :
          <Card.Text style={{ marginLeft: '22px', marginBottom: '20px', marginRight: '20px' }}>
          </Card.Text>
        )
      }
      <Row>
        <Button
          size='sm'
          as={Col}
          xs='auto'
          variant="secondary"
          className='mb-3'
          style={{ marginLeft: '32px', width: 'fit-content' }}
          onClick={handleShowMore}
        >
          {displayFullContent ? '顯示更少' : '顯示更多'}
        </Button>
        {props.variant === 'my-comment' &&
          <>
            <Button
              size='sm'
              as={Col}
              xs='auto'
              variant="success"
              className='mb-3 ms-3'
              style={{ width: 'fit-content' }}
              onClick={handleEdit}
            >
              編輯
            </Button>
            <Button
              size='sm'
              as={Col}
              xs='auto'
              variant="danger"
              className='mb-3 ms-3'
              style={{ width: 'fit-content' }}
              onClick={handleClickDelete}
            >
              刪除
            </Button>
          </>
        }
      </Row>
    </div>
  )
}

export default CommentItem;